import { DataProducerProject } from '../store/models/Project';

export const getTLProjects = (projects: DataProducerProject[], email: string) =>
  projects
    ?.filter((project) => project?.vendorProjectOwnerEmail === email)
    ?.map(({ name }) => name || '')
    ?.join(', ');
